







































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Slider } from '@/models/Slider';
import ImagePopup from '@/components/Inspiration/ImagePopup.vue';

@Component({
    components: {
        ImagePopup
    }
})
export default class ProductImageSlider extends Vue {
    @Prop({ default: () => [] }) thumbs!: Slider['thumbs'];
    @Prop({ default: () => [] }) pitcures!: Slider['pitcures'];
    @Prop({ default: '' }) navTitle!: Slider['navTitle'];
    @Prop({ default: 0 }) more!: Slider['more'];
    @Prop({ default: '' }) arShowText!: Slider['arShowText'];
    @Prop({ default: '' }) threeDCloseText!: Slider['threeDCloseText'];
    @Prop({ default: '' }) threeDOpenText!: Slider['threeDOpenText'];
    @Prop({ default: '' }) arName!: Slider['arName'];
    lastIndex: number = 0;
    lastScroll: number = 0;
    listItem: HTMLElement | null = null;
    list: HTMLElement | null = null;
    slider: HTMLElement | null = null;

    constructor() {
        super();
    }

    get getThumbs(): Slider['thumbs'] {
        return typeof this.thumbs === 'string' ? JSON.parse(this.thumbs) : this.thumbs;
    }
    get getPitcures(): Slider['pitcures'] {
        return typeof this.pitcures === 'string' ? JSON.parse(this.pitcures) : this.pitcures;
    }
    get hasArName(): boolean {
        return this.arName !== '';
    }
    showImage(e: PointerEvent, i: number): void {
        const eventElem = e.currentTarget as HTMLElement;
        if (this.listItem === null) this.sliderElement(eventElem, i);

        if (i !== this.lastIndex) {
            if (this.list !== null && this.listItem !== null) {
                let scroll = (i - this.lastIndex) * this.listItem.offsetWidth;
                if (i < this.lastIndex) {
                    scroll = this.listItem.offsetWidth * i - this.lastScroll;
                }
                this.list.scrollBy({
                    top: 0,
                    left: scroll,
                    behavior: 'smooth'
                });
            }
        }
    }

    sliderElement(eventElem: HTMLElement, i: number): void {
        this.slider = eventElem.closest('.product-image-slider');
        if (this.slider !== null) {
            this.list = this.slider.querySelector('.product-image-slider__list') as HTMLElement;
            this.listItem = this.slider.querySelector('.product-image-slider__list-item-' + i) as HTMLElement;
        }
    }
    setLastIndex(e: Event): void {
        if (e.target !== null) {
            const scrollElement = e.target as HTMLElement;
            this.lastIndex = Math.round(scrollElement.scrollLeft / scrollElement.clientWidth);
            if (this.listItem === null) {
                this.sliderElement(scrollElement, this.lastIndex);
            }
            if (this.listItem !== null) {
                this.lastScroll = this.lastIndex * this.listItem.offsetWidth;
            }
        }
    }

    imagePopup(imageUrl: string) {
        this.$modal.show(
            ImagePopup,
            {
                imageUrl,
                class: 'product-image-slider__modal'
            },
            {
                adaptive: false,
                height: '90%',
                width: '90%',
                maxWidth: 1500,
                scrollable: false
            }
        );
    }
}
